import { useNavigate } from "react-router-dom";

// Fungsi untuk memastikan panjang kunci yang valid (16 byte atau 32 byte)
const createValidAESKey = (keyString) => {
    const encoder = new TextEncoder();
    const keyBuffer = encoder.encode(keyString);

    // Pastikan kunci memiliki panjang 16 byte (128 bit) atau 32 byte (256 bit)
    if (keyBuffer.length === 16 || keyBuffer.length === 32) {
        return keyBuffer;
    }

    // Jika terlalu pendek, tambahkan padding
    if (keyBuffer.length < 16) {
        const paddedKey = new Uint8Array(16);
        paddedKey.set(keyBuffer);
        return paddedKey;
    } else if (keyBuffer.length > 16 && keyBuffer.length < 32) {
        const paddedKey = new Uint8Array(32);
        paddedKey.set(keyBuffer);
        return paddedKey;
    }

    // Jika lebih panjang dari 32 byte, potong
    return keyBuffer.slice(0, 32);
};

// Fungsi untuk mengenkripsi data
const encryptData = async (data, rawKey) => {
    try {
        // Pastikan kunci sesuai panjang yang dibutuhkan (16 atau 32 byte)
        const validKeyBuffer = createValidAESKey(rawKey);

        // Buat kunci kriptografi menggunakan kunci yang telah disesuaikan
        const key = await crypto.subtle.importKey(
            "raw",
            validKeyBuffer,
            { name: "AES-GCM" },
            false,
            ["encrypt", "decrypt"]
        );

        // Data untuk dienkripsi
        const encoder = new TextEncoder();
        const dataBuffer = encoder.encode(data);

        // Initialization Vector (IV)
        const iv = crypto.getRandomValues(new Uint8Array(12));

        // Enkripsi data
        const encryptedData = await crypto.subtle.encrypt(
            { name: "AES-GCM", iv: iv },
            key,
            dataBuffer
        );

        // Simpan hasil enkripsi di localStorage
        const encryptedObject = {
            encryptedData: Array.from(new Uint8Array(encryptedData)),
            iv: Array.from(iv),
        };
        window.localStorage.setItem("ktp", JSON.stringify(encryptedObject));

        return true; // Kembalikan status sukses
    } catch (error) {
        console.error("Error saat mengenkripsi data:", error);
        throw new Error("Enkripsi gagal.");
    }
};

// Fungsi untuk mendekripsi data
const decryptData = async (rawKey) => {
    try {
        const storedData = window.localStorage.getItem("ktp");
        if (!storedData) {
            return null
            // throw new Error("Tidak ada data enkripsi ditemukan di localStorage.");
        }

        // Ambil dan parsing data dari localStorage
        const { encryptedData, iv } = JSON.parse(storedData);

        // Pastikan kunci sesuai panjang yang dibutuhkan (16 atau 32 byte)
        const validKeyBuffer = createValidAESKey(rawKey);

        // Import kunci kriptografi
        const key = await crypto.subtle.importKey(
            "raw",
            validKeyBuffer,
            { name: "AES-GCM" },
            false,
            ["decrypt"]
        );

        // Dekripsi data
        const decryptedBuffer = await crypto.subtle.decrypt(
            { name: "AES-GCM", iv: new Uint8Array(iv) },
            key,
            new Uint8Array(encryptedData)
        );

        // Konversi buffer hasil dekripsi menjadi string
        const decoder = new TextDecoder();
        return decoder.decode(decryptedBuffer);
    } catch (error) {
        console.error("Error saat mendekripsi data:", error);
        throw new Error("Dekripsi gagal.");
    }
};

const disableSplashScreen = () => {
    const splashScreen = document.getElementById("splash-screen");
    if (splashScreen) {
        splashScreen.style.setProperty("display", "none");
    }
};

export {
    encryptData,
    decryptData,
    disableSplashScreen
}
